export enum ChecklistControllerMode {
  summary = "summary",
  reviewSteps = "reviewSteps",
}
